(function(){const root=document.getElementById("soar-hoops-content");if(!root)return;const ownedId=id=>root.querySelector("#"+CSS.escape(id));

(()=>{const home=ownedId('soar-home');if(!home)return;

// Scroll reveal
const reveals = home.querySelectorAll('.reveal');
const ro = new IntersectionObserver(entries=>{
  entries.forEach(e=>{
    if(e.isIntersecting){e.target.classList.add('on');ro.unobserve(e.target);}
  });
},{threshold:0.1});
reveals.forEach(el=>ro.observe(el));

})();

})();
(function(){const root=document.getElementById("soar-hoops-content");if(!root)return;const ownedId=id=>root.querySelector("#"+CSS.escape(id));

(()=>{const home=ownedId('soar-home');if(!home)return;

(function(){
 const section=ownedId('we-bought-stories');if(!section)return;
 const rail=section.querySelector('.stories-track'),cards=Array.from(rail.querySelectorAll('.stories-card')),dots=Array.from(section.querySelectorAll('.stories-dots button')),prev=section.querySelector('.stories-prev'),next=section.querySelector('.stories-next');
 function positions(){return cards.map(c=>c.offsetLeft-cards[0].offsetLeft);}
 function active(){if(rail.scrollLeft<=1)return 0;if(rail.scrollLeft>=rail.scrollWidth-rail.clientWidth-1)return cards.length-1;const xs=positions();return xs.reduce((best,x,i)=>Math.abs(x-rail.scrollLeft)<Math.abs(xs[best]-rail.scrollLeft)?i:best,0);}
 function scrollTo(left){rail.scrollTo({left:Math.max(0,Math.min(left,rail.scrollWidth-rail.clientWidth)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
 function go(i){scrollTo(positions()[Math.max(0,Math.min(cards.length-1,i))]);}
 function step(direction){const xs=positions();const target=direction>0?xs.find(x=>x>rail.scrollLeft+1):xs.slice().reverse().find(x=>x<rail.scrollLeft-1);scrollTo(target??(direction>0?rail.scrollWidth-rail.clientWidth:0));}
 function update(){const i=active();prev.disabled=rail.scrollLeft<=1;next.disabled=rail.scrollLeft>=rail.scrollWidth-rail.clientWidth-1;dots.forEach((d,n)=>d.setAttribute('aria-pressed',String(n===i)));section.querySelector('.stories-status').textContent='Story '+(i+1)+' of '+cards.length;}
 prev.addEventListener('click',()=>step(-1));next.addEventListener('click',()=>step(1));dots.forEach((d,i)=>d.addEventListener('click',()=>go(i)));
 rail.addEventListener('keydown',e=>{if(['ArrowLeft','ArrowRight','Home','End'].includes(e.key)){e.preventDefault();if(e.key==='Home')go(0);else if(e.key==='End')go(cards.length-1);else step(e.key==='ArrowRight'?1:-1);}});
 let drag=null;rail.addEventListener('pointerdown',e=>{if(e.pointerType!=='mouse'||e.button!==0)return;drag={x:e.clientX,left:rail.scrollLeft};rail.classList.add('is-dragging');rail.setPointerCapture(e.pointerId);e.preventDefault();rail.focus({preventScroll:true});});
 rail.addEventListener('pointermove',e=>{if(drag)rail.scrollLeft=drag.left+drag.x-e.clientX;});function stop(){drag=null;rail.classList.remove('is-dragging');update();}rail.addEventListener('pointerup',stop);rail.addEventListener('pointercancel',stop);rail.addEventListener('lostpointercapture',stop);
 rail.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update,{passive:true});update();
})();

})();

})();
(function(){const root=document.getElementById("soar-hoops-content");if(!root)return;const ownedId=id=>root.querySelector("#"+CSS.escape(id));

(()=>{const home=ownedId('soar-home');if(!home)return;

/* Supply verified business details here or through window.SOAR_CONTACT_CONFIG.
   weeklyHours uses business-local weekday numbers (0=Sunday) and HH:MM ranges.
   dateOverrides can replace weekly hours for holidays (YYYY-MM-DD: []).
   Chat status must come from the chat service, never inferred from call hours. */
window.SOAR_CONTACT_CONFIG=Object.assign({
 phone:"+13122109343",phoneLabel:"+1.312.210.9343",callHoursLabel:'',timeZone:'',weeklyHours:{},dateOverrides:{},
 chatUrl:"https://tawk.to/chat/6aab22515a40e33444be5d2c/default?layout=modern",chatStatus:'unknown',scheduleUrl:"https://calendly.com/soarbb/call"
},window.SOAR_CONTACT_CONFIG||{});
(function(){
 const cfg=window.SOAR_CONTACT_CONFIG,bar=home.querySelector('.sc-mobile-bar');if(!bar)return;
 function isStaffed(now){
  if(!cfg.timeZone||!cfg.phone)return false;
  try{
   const parts=Object.fromEntries(new Intl.DateTimeFormat('en-CA',{timeZone:cfg.timeZone,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).formatToParts(now).map(p=>[p.type,p.value]));
   const date=parts.year+'-'+parts.month+'-'+parts.day,localDay=new Date(date+'T12:00:00Z').getUTCDay(),minute=Number(parts.hour)*60+Number(parts.minute);
   const ranges=Object.prototype.hasOwnProperty.call(cfg.dateOverrides,date)?cfg.dateOverrides[date]:cfg.weeklyHours[localDay]||[];
   return ranges.some(([start,end])=>{const toMinutes=s=>s.split(':').reduce((h,m)=>Number(h)*60+Number(m));return minute>=toMinutes(start)&&minute<toMinutes(end);});
  }catch(e){return false;}
 }
 function safeWebUrl(value){try{const url=new URL(value);return ['https:','http:'].includes(url.protocol)?url.href:'';}catch(e){return '';}}
 function configure(){
  const phone=String(cfg.phone).replace(/[^+\d]/g,'');
  const links={call:phone?'tel:'+phone:'',chat:safeWebUrl(cfg.chatUrl),schedule:safeWebUrl(cfg.scheduleUrl)};
  home.querySelectorAll('[data-contact-action]').forEach(a=>{const url=links[a.dataset.contactAction];if(url){a.href=url;a.removeAttribute('aria-disabled');a.removeAttribute('tabindex');}else{a.removeAttribute('href');a.setAttribute('aria-disabled','true');a.tabIndex=-1;}});
  home.querySelectorAll('[data-call-label]').forEach(x=>x.textContent=phone?'Call '+(cfg.phoneLabel||cfg.phone):'Call Us');
  home.querySelectorAll('[data-call-hours]').forEach(x=>x.textContent=cfg.callHoursLabel||'');
  home.classList.toggle('sc-contact-enabled',Object.values(links).some(Boolean));
  refresh();updateBar();
 }
 function refresh(){
  const staffed=isStaffed(new Date());
  home.querySelectorAll('.sc-call,.sc-mobile-bar').forEach(x=>x.classList.toggle('is-staffed',staffed));
  home.querySelectorAll('[data-call-status]').forEach(x=>x.textContent=cfg.phone&&cfg.callHoursLabel&&cfg.timeZone?(staffed?'Available by phone now':'Outside staffed call hours'):'');
  home.querySelectorAll('[data-chat-status]').forEach(x=>x.textContent=cfg.chatStatus==='online'?'Chat available now':cfg.chatStatus==='offline'?'Chat currently offline':'');
 }
 let shopping=[];
 function findShopping(){shopping=Array.from(home.querySelectorAll('a,button,input[type="submit"]')).filter(el=>/shop\s+hoops|add\s+to\s+cart/i.test(el.textContent||el.value||'')||el.matches('[name="add"]'));}
 function updateBar(){
  const ready=home.classList.contains('sc-contact-enabled'),mobile=matchMedia('(max-width:749px)').matches;
  const visible=el=>{const r=el.getBoundingClientRect();return r.width>0&&r.height>0&&r.bottom>0&&r.top<innerHeight&&getComputedStyle(el).visibility!=='hidden';};
  const shoppingVisible=shopping.some(visible),contactVisible=Array.from(home.querySelectorAll('.soar-contact')).some(visible);
  const keyboardOpen=window.visualViewport&&window.visualViewport.height<innerHeight*.75;
  bar.hidden=home.getBoundingClientRect().bottom<=0||!ready||!mobile||shoppingVisible||contactVisible||keyboardOpen||!!home.querySelector('dialog[open],[aria-modal="true"]');
 }
 let queued=false;function scheduleBar(){if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;updateBar();});}
 document.addEventListener('click',e=>{if(e.target.closest('[data-contact-action][aria-disabled="true"]'))e.preventDefault();});
 window.addEventListener('soar:chat-status',e=>{if(['online','offline','unknown'].includes(e.detail?.status)){cfg.chatStatus=e.detail.status;refresh();}});
 window.addEventListener('soar:contact-config',e=>{Object.assign(cfg,e.detail||{});configure();});
 window.addEventListener('scroll',scheduleBar,{passive:true});window.addEventListener('resize',scheduleBar,{passive:true});window.visualViewport?.addEventListener('resize',scheduleBar,{passive:true});
 new MutationObserver(()=>{findShopping();scheduleBar();}).observe(home,{childList:true,subtree:true});
 document.addEventListener('visibilitychange',()=>{if(!document.hidden){refresh();scheduleBar();}});
 findShopping();configure();setInterval(refresh,30000);
})();

})();

})();
(function(){const root=document.getElementById("soar-hoops-content");if(!root)return;const ownedId=id=>root.querySelector("#"+CSS.escape(id));

// Talking SOAR Swiper
const talkingSwiper = new Swiper('#soar-hoops-content .talking-swiper', {
  slidesPerView: 'auto',
  spaceBetween: 16,
  grabCursor: true,
  freeMode: { enabled: true, sticky: false },
  navigation: {
    prevEl: '.talking-prev',
    nextEl: '.talking-next',
  },
  breakpoints: {
    0:    { slidesPerView: 1.3, spaceBetween: 12 },
    480:  { slidesPerView: 2.2, spaceBetween: 14 },
    768:  { slidesPerView: 3.3, spaceBetween: 16 },
    1100: { slidesPerView: 4.2, spaceBetween: 20 },
  },
  on: {
    slideChange: function(){
      const el = root.querySelector('.talking-counter .current');
      if(el) el.textContent = this.activeIndex + 1;
    }
  }
});

})();
(function(){const root=document.getElementById("soar-hoops-content");if(!root)return;const ownedId=id=>root.querySelector("#"+CSS.escape(id));

(function(){
  function init(){
    root.querySelectorAll('.pdetails').forEach(function(sec){
      sec.querySelectorAll('.pd-tab').forEach(function(t){
        t.addEventListener('click',function(){
          var id=t.getAttribute('data-tab');
          sec.querySelectorAll('.pd-tab').forEach(function(x){x.classList.toggle('active',x===t);});
          sec.querySelectorAll('.pd-panel').forEach(function(pn){pn.classList.toggle('active',pn.getAttribute('data-panel')===id);});
        });
      });
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();

})();
(function(){const root=document.getElementById("soar-hoops-content");if(!root)return;const ownedId=id=>root.querySelector("#"+CSS.escape(id));

(function(){
  function init(){
    root.querySelectorAll('.pfeat').forEach(function(stage){
      var dots=stage.querySelectorAll('.pf-dot');
      var tabs=stage.querySelectorAll('.pf-tab');
      var slides=stage.querySelectorAll('.pf-slide');
      var num=stage.querySelector('.pf-index span');
      var arrows=stage.querySelectorAll('.pf-arrow');
      var total=slides.length, cur=0;
      function show(i){
        cur=(i+total)%total;
        dots.forEach(function(d){d.classList.toggle('active',+d.dataset.i===cur);});
        tabs.forEach(function(t){t.classList.toggle('active',+t.dataset.i===cur);});
        slides.forEach(function(sl){sl.classList.toggle('active',+sl.dataset.i===cur);});
        if(num) num.textContent=String(cur+1).padStart(2,'0');
      }
      dots.forEach(function(d){d.addEventListener('click',function(){show(+d.dataset.i);});});
      tabs.forEach(function(t){t.addEventListener('click',function(){show(+t.dataset.i);});});
      if(arrows[0]) arrows[0].addEventListener('click',function(){show(cur-1);});
      if(arrows[1]) arrows[1].addEventListener('click',function(){show(cur+1);});
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();

})();
(function(){const root=document.getElementById("soar-hoops-content");if(!root)return;const ownedId=id=>root.querySelector("#"+CSS.escape(id));

(function(){
  function init(){
    var sec=ownedId('how-it-works'); if(!sec) return;
    var drawer=ownedId('hiwDrawer');
    var backdrop=ownedId('hiwBackdrop');
    var dots=sec.querySelectorAll('.hiw-dot');
    var slides=drawer.querySelectorAll('.hiw-slide');
    var total=slides.length, cur=0;
    function render(i){cur=(i+total)%total;slides.forEach(function(s){s.classList.toggle('active',+s.dataset.i===cur);});drawer.querySelector('.hiw-slides').scrollTop=0;}
    function open(i){render(i);drawer.classList.add('open');backdrop.classList.add('open');drawer.setAttribute('aria-hidden','false');}
    function close(){drawer.classList.remove('open');backdrop.classList.remove('open');drawer.setAttribute('aria-hidden','true');}
    dots.forEach(function(d){d.addEventListener('click',function(){open(+d.dataset.i);});});
    ownedId('hiwClose').addEventListener('click',close);
    backdrop.addEventListener('click',close);
    ownedId('hiwPrev').addEventListener('click',function(){render(cur-1);});
    ownedId('hiwNext').addEventListener('click',function(){render(cur+1);});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();

})();

/* Talking SOAR — tap to play a testimonial video; only one plays at a time. */
(function(){
  var root = document.getElementById('soar-hoops-content');
  if (!root) return;
  var cards = root.querySelectorAll('[data-talk-card]');
  if (!cards.length) return;
  function stopOthers(keep){
    cards.forEach(function(c){
      if (c === keep) return;
      c.classList.remove('is-playing');
      var v = c.querySelector('[data-talk-video]');
      if (v) { v.pause(); v.controls = false; }
    });
  }
  cards.forEach(function(card){
    var video = card.querySelector('[data-talk-video]');
    var btn   = card.querySelector('[data-talk-play]');
    if (!video) return;
    function play(e){
      if (e) e.stopPropagation();
      stopOthers(card);
      card.classList.add('is-playing');
      video.controls = true;
      var r = video.play();
      if (r && r.catch) r.catch(function(){});
    }
    if (btn) btn.addEventListener('click', play);
    card.addEventListener('click', function(e){
      if (card.classList.contains('is-playing')) return;
      play(e);
    });
    video.addEventListener('ended', function(){
      card.classList.remove('is-playing');
      video.controls = false;
    });
  });
})();
